import { defineComponent as _defineComponent } from 'vue'
import SidebarFilterBadgesContainer from '@/fields/components/SidebarFilterBadgesContainer.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityTypeFilters',
  props: {
    activityTypes: null,
    activeFilters: null
  },
  setup(__props: any) {

const props = __props as {
  activityTypes: string[];
  activeFilters: string[];
}



return { __sfc: true,props, SidebarFilterBadgesContainer }
}

})